__turbopack_context__.v({
  "item": "c0Ghoq_item",
});
